import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import axios from 'axios'
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios'
import type {
  GetNotificationById200,
  GetNotificationById401,
  GetNotificationById404,
  GetNotificationSettings200,
  GetNotificationSettings401,
  NotificationGetNotifications200,
  NotificationGetNotifications401,
  NotificationGetNotificationsParams,
  ReadAllNotifications200,
  ReadAllNotifications401,
  SubscribeToNotifications401,
  SubscribeToNotifications404,
  UpdateNotificationReadStatus200,
  UpdateNotificationReadStatus401,
  UpdateNotificationReadStatus404,
  UpdateNotificationSettings200,
  UpdateNotificationSettings400,
  UpdateNotificationSettings401,
  UpdateNotificationSettingsBody
} from './types'


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;



/**
 * 현재 로그인한 사용자의 알림 목록을 조회합니다.
 * @summary 알림 목록 조회
 */
export const notificationGetNotifications = (
    params?: NotificationGetNotificationsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<NotificationGetNotifications200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/notifications`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getNotificationGetNotificationsQueryKey = (params?: NotificationGetNotificationsParams,) => {
    return [`https://api.ugot.uk/api/notifications`, ...(params ? [params]: [])] as const;
    }

    
export const getNotificationGetNotificationsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof notificationGetNotifications>>, TError = AxiosError<NotificationGetNotifications401>>(params?: NotificationGetNotificationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationGetNotifications>>> = ({ signal }) => notificationGetNotifications(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationGetNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationGetNotifications>>>
export type NotificationGetNotificationsInfiniteQueryError = AxiosError<NotificationGetNotifications401>

/**
 * @summary 알림 목록 조회
 */
export const useNotificationGetNotificationsInfinite = <TData = Awaited<ReturnType<typeof notificationGetNotifications>>, TError = AxiosError<NotificationGetNotifications401>>(
 params?: NotificationGetNotificationsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationGetNotificationsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationGetNotifications>>, TError = AxiosError<NotificationGetNotifications401>>(params?: NotificationGetNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationGetNotifications>>> = ({ signal }) => notificationGetNotifications(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type NotificationGetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationGetNotifications>>>
export type NotificationGetNotificationsQueryError = AxiosError<NotificationGetNotifications401>

/**
 * @summary 알림 목록 조회
 */
export const useNotificationGetNotifications = <TData = Awaited<ReturnType<typeof notificationGetNotifications>>, TError = AxiosError<NotificationGetNotifications401>>(
 params?: NotificationGetNotificationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof notificationGetNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getNotificationGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 알림의 상세 정보를 조회합니다.
 * @summary 알림 상세 조회
 */
export const getNotificationById = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetNotificationById200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/notifications/${id}`,options
    );
  }


export const getGetNotificationByIdQueryKey = (id: number,) => {
    return [`https://api.ugot.uk/api/notifications/${id}`] as const;
    }

    
export const getGetNotificationByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationById>>, TError = AxiosError<GetNotificationById401 | GetNotificationById404>>(id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationById>>> = ({ signal }) => getNotificationById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationById>>>
export type GetNotificationByIdInfiniteQueryError = AxiosError<GetNotificationById401 | GetNotificationById404>

/**
 * @summary 알림 상세 조회
 */
export const useGetNotificationByIdInfinite = <TData = Awaited<ReturnType<typeof getNotificationById>>, TError = AxiosError<GetNotificationById401 | GetNotificationById404>>(
 id: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationByIdInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNotificationByIdQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationById>>, TError = AxiosError<GetNotificationById401 | GetNotificationById404>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationById>>> = ({ signal }) => getNotificationById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationById>>>
export type GetNotificationByIdQueryError = AxiosError<GetNotificationById401 | GetNotificationById404>

/**
 * @summary 알림 상세 조회
 */
export const useGetNotificationById = <TData = Awaited<ReturnType<typeof getNotificationById>>, TError = AxiosError<GetNotificationById401 | GetNotificationById404>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationById>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationByIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 알림을 읽음 상태로 변경합니다.
 * @summary 알림 읽음 처리
 */
export const updateNotificationReadStatus = (
    id: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateNotificationReadStatus200>> => {
    
    return axios.patch(
      `https://api.ugot.uk/api/notifications/${id}`,undefined,options
    );
  }



export const getUpdateNotificationReadStatusMutationOptions = <TError = AxiosError<UpdateNotificationReadStatus401 | UpdateNotificationReadStatus404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationReadStatus>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationReadStatus>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationReadStatus>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  updateNotificationReadStatus(id,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationReadStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationReadStatus>>>
    
    export type UpdateNotificationReadStatusMutationError = AxiosError<UpdateNotificationReadStatus401 | UpdateNotificationReadStatus404>

    /**
 * @summary 알림 읽음 처리
 */
export const useUpdateNotificationReadStatus = <TError = AxiosError<UpdateNotificationReadStatus401 | UpdateNotificationReadStatus404>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationReadStatus>>, TError,{id: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationReadStatus>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getUpdateNotificationReadStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 사용자의 모든 알림을 읽음 상태로 변경합니다.
 * @summary 모든 알림 읽음 처리
 */
export const readAllNotifications = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ReadAllNotifications200>> => {
    
    return axios.post(
      `https://api.ugot.uk/api/notifications/read/all`,undefined,options
    );
  }



export const getReadAllNotificationsMutationOptions = <TError = AxiosError<ReadAllNotifications401>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof readAllNotifications>>, void> = () => {
          

          return  readAllNotifications(axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReadAllNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof readAllNotifications>>>
    
    export type ReadAllNotificationsMutationError = AxiosError<ReadAllNotifications401>

    /**
 * @summary 모든 알림 읽음 처리
 */
export const useReadAllNotifications = <TError = AxiosError<ReadAllNotifications401>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof readAllNotifications>>, TError,void, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof readAllNotifications>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getReadAllNotificationsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 사용자의 알림 설정을 조회합니다.
 * @summary 알림 설정 조회
 */
export const getNotificationSettings = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetNotificationSettings200>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/notifications/settings`,options
    );
  }


export const getGetNotificationSettingsQueryKey = () => {
    return [`https://api.ugot.uk/api/notifications/settings`] as const;
    }

    
export const getGetNotificationSettingsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = AxiosError<GetNotificationSettings401>>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSettings>>> = ({ signal }) => getNotificationSettings({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationSettingsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationSettings>>>
export type GetNotificationSettingsInfiniteQueryError = AxiosError<GetNotificationSettings401>

/**
 * @summary 알림 설정 조회
 */
export const useGetNotificationSettingsInfinite = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = AxiosError<GetNotificationSettings401>>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationSettingsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNotificationSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = AxiosError<GetNotificationSettings401>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationSettings>>> = ({ signal }) => getNotificationSettings({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNotificationSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationSettings>>>
export type GetNotificationSettingsQueryError = AxiosError<GetNotificationSettings401>

/**
 * @summary 알림 설정 조회
 */
export const useGetNotificationSettings = <TData = Awaited<ReturnType<typeof getNotificationSettings>>, TError = AxiosError<GetNotificationSettings401>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNotificationSettings>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNotificationSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 사용자의 알림 설정을 업데이트합니다.
 * @summary 알림 설정 업데이트
 */
export const updateNotificationSettings = (
    updateNotificationSettingsBody: UpdateNotificationSettingsBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<UpdateNotificationSettings200>> => {
    
    return axios.put(
      `https://api.ugot.uk/api/notifications/settings`,
      updateNotificationSettingsBody,options
    );
  }



export const getUpdateNotificationSettingsMutationOptions = <TError = AxiosError<UpdateNotificationSettings400 | UpdateNotificationSettings401>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: UpdateNotificationSettingsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: UpdateNotificationSettingsBody}, TContext> => {
const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationSettings>>, {data: UpdateNotificationSettingsBody}> = (props) => {
          const {data} = props ?? {};

          return  updateNotificationSettings(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationSettings>>>
    export type UpdateNotificationSettingsMutationBody = UpdateNotificationSettingsBody
    export type UpdateNotificationSettingsMutationError = AxiosError<UpdateNotificationSettings400 | UpdateNotificationSettings401>

    /**
 * @summary 알림 설정 업데이트
 */
export const useUpdateNotificationSettings = <TError = AxiosError<UpdateNotificationSettings400 | UpdateNotificationSettings401>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationSettings>>, TError,{data: UpdateNotificationSettingsBody}, TContext>, axios?: AxiosRequestConfig}
): UseMutationResult<
        Awaited<ReturnType<typeof updateNotificationSettings>>,
        TError,
        {data: UpdateNotificationSettingsBody},
        TContext
      > => {

      const mutationOptions = getUpdateNotificationSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 사용자의 실시간 알림을 위한 SSE(Server-Sent Events) 연결을 수립합니다.
 * @summary 실시간 알림 구독
 */
export const subscribeToNotifications = (
    userId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    
    return axios.get(
      `https://api.ugot.uk/api/notifications/sse/subscribe/${userId}`,options
    );
  }


export const getSubscribeToNotificationsQueryKey = (userId: number,) => {
    return [`https://api.ugot.uk/api/notifications/sse/subscribe/${userId}`] as const;
    }

    
export const getSubscribeToNotificationsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof subscribeToNotifications>>, TError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>>(userId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscribeToNotificationsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscribeToNotifications>>> = ({ signal }) => subscribeToNotifications(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type SubscribeToNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof subscribeToNotifications>>>
export type SubscribeToNotificationsInfiniteQueryError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>

/**
 * @summary 실시간 알림 구독
 */
export const useSubscribeToNotificationsInfinite = <TData = Awaited<ReturnType<typeof subscribeToNotifications>>, TError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>>(
 userId: number, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSubscribeToNotificationsInfiniteQueryOptions(userId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getSubscribeToNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof subscribeToNotifications>>, TError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>>(userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubscribeToNotificationsQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof subscribeToNotifications>>> = ({ signal }) => subscribeToNotifications(userId, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(userId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData> & { queryKey: QueryKey }
}

export type SubscribeToNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof subscribeToNotifications>>>
export type SubscribeToNotificationsQueryError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>

/**
 * @summary 실시간 알림 구독
 */
export const useSubscribeToNotifications = <TData = Awaited<ReturnType<typeof subscribeToNotifications>>, TError = AxiosError<SubscribeToNotifications401 | SubscribeToNotifications404>>(
 userId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subscribeToNotifications>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getSubscribeToNotificationsQueryOptions(userId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



